import script from "./childManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./childManage.vue?vue&type=script&lang=ts&setup=true"

import "./childManage.vue?vue&type=style&index=0&id=1c5dd8d2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5dd8d2"]])

export default __exports__